import React from 'react';

export interface LoadingStatusProps {
  /** The loading message to display */
  message: string;
  /** Additional CSS classes for the container */
  className?: string;
}

/**
 * LoadingStatus component displays a loading indicator with a pulsing blue dot
 * and a message. Used to show loading states during authentication and other async operations.
 */
export const LoadingStatus: React.FC<LoadingStatusProps> = ({ message, className = '' }) => {
  return (
    <div className={`flex items-center gap-2 text-xs text-gray-600 animate-pulse ${className}`}>
      <div className='h-1.5 w-1.5 bg-brand rounded-full animate-pulse' />
      <span>{message}</span>
    </div>
  );
};
